import Viewer from "../../components/Viewers/Viewer";
import { useLocation } from "react-router-dom";

const Focus = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const images = JSON.parse(queryParams.get("images") || "[]");
  const index = parseInt(queryParams.get("index") || "0");
  const coordinates = JSON.parse(queryParams.get("coordinates") || "{}");
  const dimensions = JSON.parse(queryParams.get("dimensions") || "{}");
  return (
    <div className="flex h-full w-full justify-center pad-5">
      {images ? (
        <Viewer
          images={images}
          index={index}
          coordinates={coordinates}
          dimensions={dimensions}
          isFullScreen
        />
      ) : (
        <div className="flex justify-center pad-30">Focus Mode Unavailable</div>
      )}
    </div>
  );
};

export default Focus;
